import { Html } from '@react-three/drei';
import CommonButton from 'components/CommonButton';
import { ControlContext } from 'provider/ControlProvider';
import { useContext, useEffect, useRef, useState } from 'react';
import { Scrollbars } from 'react-custom-scrollbars-2';

type Props = {
  url?: string;
  title?: string;
  description?: string;
  price?: number;
  pos?: Array<number>;
  scale?: number;
  orbit?: any;
  id?: string;
  variantId: string;
};

export default function FlipCard({
  url = '/product/1.png',
  title = 'Jester Groundberry',
  description = `
  The Jester Groundberry is popular for its ornamental value, 
  adding a unique splash of color to rock gardens, border plantings, 
  and mixed containers.
  It also attracts pollinators like bees and butterflies, making it a great 
  choice for gardeners interested in supporting local wildlife populations.
  In some cultures, the plant has been used medicinally to treat a range of ailments, 
  though there is limited scientific research on its efficacy and safety for human use.`,
  price = 15,
  pos = [10, -5, -10],
  scale = 0.5,
  orbit = null,
  id = 'null',
  variantId = '',
}: Props) {
  const transform = useRef<any>();
  const { cart, setCart } = useContext(ControlContext);
  const [num, setNum] = useState<number>(1);
  const handleInputChange = (event: any) => {
    const { value } = event.target;
    setNum(+value.replace(/[^0-9]/g, 1)); // Replace anything other than numbers with an empty string
  };
  useEffect(() => {
    if (transform.current) {
      const controls: any = transform.current;
      const callback = (event: any) => {
        orbit.current.enabled = !event.value;
      };
      controls.addEventListener('dragging-changed', callback);
      return () => controls.removeEventListener('dragging-changed', callback);
    }
  });
  const addCart = () => {
    let tempData = cart;
    const index = cart.findIndex((item) => item.productId === id);

    const data = {
      productId: id,
      quantity: num,
      variantId: variantId,
    };
    if (index > -1) {
      tempData[index] = {
        productId: id,
        quantity: num + cart[index].quantity,
        variantId: variantId,
      };
    } else tempData = [...cart, data];
    localStorage.setItem('Cart', JSON.stringify([...tempData]));
    setCart([...tempData]);
  };
  return (
    <Html transform sprite position={[pos[0], pos[1], pos[2]]} scale={scale}>
      <div className='flip-card'>
        <div className='flip-card-inner'>
          <div className='flip-card-front'>
            <img
              src={url}
              alt={'Spore&aposs ' + title}
              className='p-12'
              style={{ width: '300px', height: '300px' }}
            />
          </div>
          <div
            className='flip-card-back p-6  overflow-hidden bg-zinc-800'
            ref={transform}
          >
            <p className='text-2xl font-bold'>{title}</p>
            <div className='flex justify-end mb-3'>
              <p>Price: </p>
              <p>{' ' + price + '$'}</p>
            </div>

            <Scrollbars
              className='w-full text-left overflow-x-hidden'
              autoHeight
            >
              <p>{description}</p>
            </Scrollbars>
            <div className='flex justify-center items-center space-x-2 text-xl mt-1'>
              <button
                className='px-4 py-1 hover:text-zinc-200 border border-zinc-500'
                onClick={(e) => {
                  e.stopPropagation();
                  if (num > 1) setNum(num - 1);
                }}
              >
                -
              </button>
              <input
                type='text'
                className='bg-zinc-800 w-10 text-center p-2'
                value={num}
                onChange={handleInputChange}
                placeholder='0'
              />
              <button
                className='px-4 py-1 hover:text-zinc-200 border border-zinc-500'
                onClick={(e) => {
                  e.stopPropagation();
                  setNum(num + 1);
                }}
              >
                +
              </button>
            </div>
            <div className='flex justify-center'>
              <CommonButton className='my-4 w-full' onClick={() => addCart()}>
                Add Cart
              </CommonButton>
            </div>
          </div>
        </div>
      </div>
    </Html>
  );
}
